<div class="header-rule flex justify-content-end">
  @if(!isOnline) {
  <div class="internet-offline-overlay"></div>
  <div class="internet-offline-message">
    <div class="offline-alert">
      <i class="pi pi-wifi" style="margin-right: 8px;"></i>
      <span translate>lbl_no_internet_connection</span>
    </div>
  </div>
  }
  <ul class="header--menu fadeInDown flex flex-row">
    <li class="flex align-items-center">
      <label class="font-semibold" id="timezone"></label>
    </li>
    <li>
      <a class="bg-white top-7" (click)="goToSettings()"><span><i
            class="{{miIcon.SETTINGS}} inline-block wh-22"></i></span></a>
    </li>
    <li>
      <a class="bg-white top-7" (click)="openNotificationTray()"><span><i class="pi pi-bell text-2xl" pBadge
            [value]="unReadNotificationsCount > 99 ? '99+' : unReadNotificationsCount"  severity="success"
            [badgeDisabled]="!unReadNotificationsCount"></i></span></a>
    </li>
    <li class="user-profile" (click)="onProfileClick($event)" (mouseenter)="showMenu()">
      <div class="img-background relative height-40-px width-40-px border-circle surface-300 cursor-pointer">
        <span class="image-name text-lg font-bold">{{createAcronym(profileData?.email)}}</span>
      </div>
      @if(showPopUp){
      <ul class="fadeInDown" (mouseenter)="showMenu()" (mouseleave)="hideMenu()">
        <li role="menuitem" (click)="goToSettings()"><a href="#"><span>Edit Profile</span><i
              class="{{miIcon.USER_CIRCLE}} inline-block wh-24"></i></a></li>
        <li role="menuitem" (click)="goToChangePassword()"><a href="#"><span>Change Password</span><i
              class="{{miIcon.PASSWORD}} inline-block wh-24"></i></a></li>
        <li role="menuitem" (click)="doSignOut()"><a href="#"><span>Logout</span><i
              class="{{miIcon.LOG_OUT}} inline-block wh-24"></i></a></li>
      </ul>
      }
    </li>
  </ul>

</div>

<app-notification-tray
  [notifications]="notifications"
  (loadMore)="loadMoreNotifications()"
  [notificationParams]="notificationParams"
  (markAllRead)="markAllReadNotifications()"
  [unReadNotificationsCount]="unReadNotificationsCount"
  [notificationCount]="notificationCount"></app-notification-tray>

<p-confirmDialog
  header="Confirmation"
  [closable]="true"
  [dismissableMask]="true"></p-confirmDialog>